import Tab from "@mui/material/Tab";
import Tabs from "@mui/material/Tabs";
import isString from "lodash/isString";

const TabSwitcher = ({ value, onChange, tabs, sx, wrap = false, fontSize }) => {
  const handleChange = (event, newValue) => {
    onChange(newValue);
  };

  return (
    <Tabs
      value={value}
      onChange={handleChange}
      className="tab-switcher-root"
      aria-label="basic tab switcher"
      sx={{
        ...(wrap && {
          "& .MuiTabs-flexContainer": {
            flexWrap: "wrap",
          },
          "& .MuiTabs-indicator": {
            display: "none",
          },
          "& .MuiTab-root": {
            borderBottom: "2px solid transparent",
          },
          ".Mui-selected": {
            borderBottom: "2px solid",
            borderColor: "#1F5AF2",
            backgroundColor: "#1F5AF20e",
          },
        }),
        ...(fontSize && {
          "& .MuiTab-root": {
            fontSize,
          },
        }),
        ...sx,
      }}
    >
      {tabs?.map((tab) => {
        const tab_label = isString(tab) ? tab : tab?.label;
        const tab_value = isString(tab) ? tab : tab?.value;

        return <Tab key={tab_value} label={tab_label} value={tab_value} />;
      })}
    </Tabs>
  );
};
// const TabSwitcher = ({ value, onChange, tabs, sx }) => {
//   const handleChange = (event, newValue) => {
//     onChange(newValue);
//   };

//   return (
//     <Tabs
//       value={value}
//       onChange={handleChange}
//       className="tab-switcher-root"
//       aria-label="basic tab switcher"
//       sx={sx}
//     >
//       {tabs?.map((tab) => {
//         const tab_label = isString(tab) ? tab : tab?.label;
//         const tab_value = isString(tab) ? tab : tab?.value;

//         return <Tab key={tab_value} label={tab_label} value={tab_value} />;
//       })}
//     </Tabs>
//   );
// };

export default TabSwitcher;
